import { render, staticRenderFns } from "./cover-image.vue?vue&type=template&id=c07ce1a4&"
import script from "./cover-image.vue?vue&type=script&lang=js&"
export * from "./cover-image.vue?vue&type=script&lang=js&"
import style0 from "./cover-image.vue?vue&type=style&index=0&id=c07ce1a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports